"use client";

import { useEffect } from "react";
import { useSession } from "@/lib/auth/client";
import { useAnalytics } from "@/lib/analytics/client";
import { useErrorTracking } from "@/lib/errors/client";

export default function IdentifyUser() {
  const { data: session } = useSession();
  const analytics = useAnalytics();
  const errors = useErrorTracking();

  useEffect(() => {
    const userId = session?.user?.id;
    if (userId) {
      analytics.identify(userId);
      void errors.setUser({ id: userId, email: session?.user?.email });
    } else {
      void errors.setUser(null);
    }
  }, [session, analytics, errors]);

  return null;
}
